import Transform from './Base';

function numToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(c) {
  return c.map(x => numToHex(x)).reduce((total, a) => total.concat(a), "#");
}

export default class DataTransform extends Transform {
  /**
   * Method used to transform fetched detections data.
   *
   * @param frame The fetched job.
   *
   * @returns {Object} The transformed job.
   */

  static fetch(frame) {
    let res;
    try {
      res = {
        acceleration: frame.acceleration,
        ball_possession: frame.ball_possession || false,
        distance: frame.travelled_distance,
        id: frame._id || Math.random().toString(36).substring(2),
        track_id: frame.track_id !== undefined ? frame.track_id : '',
        frame_id: frame.frame_id,
        interpolation: frame.interpolation,
        job_id: frame.job_id,
        color: rgbToHex(frame.color),
        box: {
          x: frame.x_camera,
          y: frame.y_camera,
          w: frame.box_w,
          h: frame.box_h,
        },
        canonical: {
          x: frame.x_rel,
          y: frame.y_rel,
        },
        object_type_id: frame.object_type_id,
        object_type_prob: frame.object_type_prob,
        player: frame?.player || {},
        speed: frame.speed,
        team_id: frame.team_id,
        z: frame.z || 0,
      };
    } catch {
      res = null;
    }
    return res;
  }

  static fieldCollection(items) {
    return items.map(item => this.field(item));
  }

  static field(frame) {
    try {
      return {
        color: 'red',
        id: Math.random().toString(36).substring(2),
        point: frame.point,
        x: frame.x_rel,
        y: frame.y_rel,
      };
    } catch {
      return null;
    }
  }
}
